export default "__VITE_ASSET__f2cf4f91__"